import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import InputTextField from "../../../Components/InputTextField/InputTextField";
import brandIsa from "../../../Assets/images/brand-isa.svg";
import validations from "../../../Utils/Validations/Validations";
import { useToast } from "../../../Hooks/useToast";
import { ActivarCuentaService } from "../Services/ActivarCuentaService";

const ActivarCuenta = () => {
	const params = useParams();
	const parametrosUrl = {
		idUsuario : atob(params.id),
		token : params.token
	}
	const navigate = useNavigate();
	const addToast = useToast();
	async function postActivarCuenta(values) {
		const resp = await ActivarCuentaService(values);
		if (resp) {
			if (resp.status === 200) {
				navigate("/", { replace: true });
				addToast({ mostrar: true, mensaje: 'Cuenta activada correctamente.', titulo: 'Confirmación', tipo: 'Success' });
			}
		}
	}
	const ActivarPass = (values) => {
		const parametros = {
			id: parametrosUrl.idUsuario,
			token: parametrosUrl.token,
			clave: values.password
		}
		postActivarCuenta(parametros);
	}
	return (
		<div className="container min-vh-100">
			<div className="row justify-content-center align-items-center min-vh-100">
				<div className="col-12 col-md-6 col-lg-5 col-xl-4">
					<div className="card card--login">
						<div className="card-body p-4 p-md-5">
							<img className="d-flex mb-5 mx-auto" src={brandIsa} width="187" alt="ruta loa" />
							<span className="fs-4 text-pewter-blue mb-4 d-block">Activar cuenta</span>
							<Formik
								initialValues={{ password: '', verification: '' }}
								validate={validations}
								onSubmit={async (values, { setSubmitting, resetForm }) => {
									setSubmitting(false)
									ActivarPass(values);
								}}
							>
								{({
									values,
									setFieldValue,
								}) => (
									<Form className="form mb-0">
									<InputTextField
										name="password"
										label="Contraseña"
										type="password"
										placeholder="nueva"
										autoComplete="false"
										maxLength="20"
										className="form-floating--material"
									/>
									<InputTextField
										name="verification"
										label="Confirmar Contraseña"
										type="password"
										placeholder="confirmación"
										autoComplete="false"
										maxLength="20"
										className="form-floating--material"
									/>
										<div className="d-grid">
											<button type="submit" className="btn btn-primary">Enviar</button>
										</div>
									</Form>
								)}
							</Formik>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ActivarCuenta;
